
import useViewport from "components/general/useViewPort";
import React, { createContext, useReducer } from "react";





//Only State Data
const LegendsDataContext = createContext(null)
//Functions update context Data
const LegendsDispatchContext = createContext(null)




// A "provider" is used to encapsulate only the
// components that needs the state in this context
function LegendProvider({ children }) {
    const [state, dispatch] = useReducer(legendReducer, { legends: { data: [] }, expandedElementsTable: [] })

    return (
        <LegendsDataContext.Provider value={state}>
            <LegendsDispatchContext.Provider value={dispatch}>
                {children}
            </LegendsDispatchContext.Provider>
        </LegendsDataContext.Provider>
    );
}

export { LegendProvider, useDataLegends, useDispatchLegends };




function legendReducer(state, action) {
    switch (action.type) {

        case 'resetLegends':
            return {
                ...state, legends: { data: [] }
            };

        case 'removeAllLegend':
            const fixedLegeds = Array.isArray(state.legends.data) ? state.legends.data.filter(item => item.legendFixed) : []
            let expandedLegeds = Array.isArray(state.legends.data) ? state.legends.data.filter(item => item.expandedId) : []
            expandedLegeds = expandedLegeds.filter(item => state.expandedElementsTable.includes(item.expandedId));
            return {
                ...state, legends: { data: [...fixedLegeds, ...expandedLegeds] }
            };
        case 'addlegend': {
            const legends = state?.legends?.data
            let resp = false
            if (action.payload?.id) {
                resp = Array.isArray(legends) && legends.some(element => (element?.id === action.payload?.id && element?.expandedId === action.payload?.expandedId));
                if (resp) {
                    return Object.assign({}, state, {
                        legends: { data: state.legends.data }

                    });
                }
                return { ...state, legends: { data: [...state.legends.data, action.payload] } }

            } else {
                return { ...state }
            }
        }
        case 'expandedElementsTable': {
            const normalLegeds = Array.isArray(state.legends.data) ? state.legends.data.filter(item => !item.expandedId) : []
            let expandedLegeds = Array.isArray(state.legends.data) ? state.legends.data.filter(item => item.expandedId) : []
            expandedLegeds = expandedLegeds.filter(item => action.payload.includes(item.expandedId));
            let obj = { ...state, legends: { data: [...normalLegeds, ...expandedLegeds] }, expandedElementsTable: action.payload }
            return (obj)
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }
    }
}

function useDataLegends() {
    const context = React.useContext(LegendsDataContext)
    const { breakPoint } = useViewport()
    LegendsDataContext.breakPoint = breakPoint
    if (context === undefined) {
        //throw new Error('useCount must be used within a CountProvider')
        return null
    }
    return context
}



function useDispatchLegends() {
    const context = React.useContext(LegendsDispatchContext)
    if (context === undefined) {
        //throw new Error('useCount must be used within a CountProvider')
        return null
    }
    return context
}

